import axios from "axios";

import SharedHandler from "src/components/UI/Shared/handler";

class user {
  public static signOut = () => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const new_data = user_data;
      if (current_user !== "guest")
        new_data.session_token.status = "logged-out";
      new_data.locked = "unlocked";
      const guest = { ip_data: user_data["ip_data"] };
      localStorage.setItem("guest", JSON.stringify(guest));
      localStorage.setItem(current_user, JSON.stringify(new_data));
    }
    window.location.reload();
  };
  public static getCurrentLoggedIn = () => {
    let logged_in = "guest";
    const localStorageData = (localStorage || {}) as Storage;
    Object.keys(localStorageData)?.forEach((key: string) => {
      const value = localStorage.getItem(key);
      if (value) {
        try {
          const data = JSON.parse(value);
          try {
            if (data.session_token && data.session_token.status === "logged-in")
              logged_in = key;
          } catch {
            return "guest";
          }
        } catch {}
      }
    });
    return logged_in;
  };
  public static getLoggedInLockCode = () => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    let lock_code;
    if (data) {
      const user_data = JSON.parse(data);
      lock_code = user_data["GiSimplifyLockCode"];
    }
    return lock_code;
  };
  public static setLoggedInLock = (key: string) => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const new_data = user_data;
      new_data["locked"] = key;
      localStorage.setItem(current_user, JSON.stringify(new_data));
    }
  };
  public static setLoggedInLockCode = (code: string) => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const new_data = user_data;
      new_data["GiSimplifyLockCode"] = code;
      localStorage.setItem(current_user, JSON.stringify(new_data));
    }
  };
  public static setLoggedInSessionToken = (code: string) => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    if (data) {
      const user_data = JSON.parse(data);
      const new_data = user_data;
      new_data["GiSimplifyLockCode"] = code;
      localStorage.setItem(current_user, JSON.stringify(new_data));
    }
  };
  public static checkUserIp = async (user_data: any, current_user: string) => {
    console.log("------check user ip--------");

    const apiURL = process.env.REACT_APP_API_URL || "";

    const currentTime = new Date().getTime();
    const timeDifference = currentTime - user_data.ip_data.timestamp;

    const endpointUrl = "user/user_tracking/";
    const timestamp = new Date().toISOString();
    const signature = SharedHandler.signRequest(
      "/" + endpointUrl,
      "POST",
      timestamp
    );
    if (timeDifference > 3600000) {
      const formData = new FormData();
      formData.append("user_ip", user_data.ip_data.ip);

      try {
        await axios
          .post(apiURL + endpointUrl, formData, {
            headers: {
              "X-Signature": signature,
              "X-Timestamp": timestamp,
            },
          })
          .then((response) => {
            const new_data = user_data;
            new_data.ip_data.timestamp = currentTime;
            localStorage.setItem(current_user, JSON.stringify(new_data));
          });
      } catch (error) {}
    }
  };
  public static getUserIp = async (current_user: string, user_data?: any) => {
    console.log("------get user ip--------");
    const apiURL = process.env.REACT_APP_API_URL || "";
    const timestamp = new Date().toISOString();
    const endpointUrl = "user/user_tracking/";
    const signature = SharedHandler.signRequest(
      "/" + endpointUrl,
      "POST",
      timestamp
    );
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then(async (data) => {
        const user_ip = data.ip;
        const currentTime = new Date().getTime();
        const ip_data = {
          ip: user_ip,
          timestamp: currentTime,
          guid: "",
          map: 0,
        };
        const new_data = user_data ? user_data : { ip_data: {} };
        new_data.ip_data = ip_data;
        localStorage.setItem(current_user, JSON.stringify(new_data));
        const formData = new FormData();
        formData.append("user_ip", user_ip);

        await axios
          .post(apiURL + endpointUrl, formData, {
            headers: {
              "X-Signature": signature,
              "X-Timestamp": timestamp,
            },
          })

          .catch((error) => {});
      })
      .catch((error) => {});
  };
  public static parseUserIp = () => {
    const current_user = user.getCurrentLoggedIn();
    const data = localStorage.getItem(current_user);
    let ip = "";
    if (data) {
      const user_data = JSON.parse(data);
      ip = user_data?.ip_data.ip;
    }
    return ip;
  };
  public static parseUserEmail = () => {
    const current_user = user.getCurrentLoggedIn();
    const data =
      current_user !== "guest" ? localStorage.getItem(current_user) : null;
    let email = "";
    if (data) {
      const user_data = JSON.parse(data);
      email = user_data.session_token.email;
    }
    return email;
  };
  public static getUserCredits = async (email: string) => {
    const apiURL = process.env.REACT_APP_API_URL;
    console.log(email);
    const endpointUrl = "credit/getCurrentBalance/";
    const timestamp = new Date().toISOString();
    const signature = SharedHandler.signRequest(
      "/" + endpointUrl,
      "POST",
      timestamp
    );
    const formData = new FormData();
    formData.append("user_email", email);

    let currentBalance = 0;
    try {
      await axios
        .post(apiURL + endpointUrl, formData, {
          headers: {
            "X-Signature": signature,
            "X-Timestamp": timestamp,
          },
        })
        .then((response) => {
          if (response.data && response.data.balance) {
            currentBalance = response.data.balance;
          }
        });
    } catch (error) {}
    return currentBalance;
  };
}
export default user;
